import { sendSoapRequest, createSoapEnvelope } from './soapClient.js'; // Import the SOAP request function

// Function to create a prompt using the SOAP API
const createSpeedDial = async (speeddialData,username, password, setProgress) => {
  // Construct the XML body for the prompt creation
  const body = `
    <ser:createSpeedDialNumber>
                        <code>${speeddialData.Code}</code>
                        <number>${speeddialData.Phone}</number>
                        <description>${speeddialData.Description}</description>
                    </ser:createSpeedDialNumber>
  `;

  // Wrap the body in a SOAP envelope
  const soapBody = createSoapEnvelope(body);

  try {
    // Send the SOAP request
    console.log('Speed Dial request body:', soapBody);
    const result = await sendSoapRequest('createSpeedDialNumber', soapBody, username, password);
    console.log(`Speed Dial ${speeddialData.Code} created successfully:`, result);
    setProgress(prev => [...prev, `Speed Dial created successfully: ${speeddialData.Code}`]); // Update progress here
    return result; // Return the result from the SOAP response
  } catch (error) {
    console.error(`Error creating Speed Dial ${speeddialData.Code}:`, error);
    setProgress(prev => [...prev, `Error creating Speed Dial ${speeddialData.Code}: ${error.message}`]);
    throw error; // Re-throw the error for further handling if needed
  }
};

export default createSpeedDial;